<template>
  <div>
    <EditPurchasedLicenseList v-if="this.$route.params.object_name === 'purchasedLicenses'" />
    <EditInvestigatorList
      v-if="this.$route.params.object_name === 'researchers'"
    />
    <EditPublicationList
      v-if="this.$route.params.object_name === 'publications'"
    />
    <EditWorkplaceList v-if="this.$route.params.object_name === 'workplaces'" />
    <EditServiceList
      v-else-if="this.$route.params.object_name === 'services'"
    />
    <EditCategoryList
      v-else-if="this.$route.params.object_name === 'categories'"
    />
    <EditOrganizationList
      v-else-if="this.$route.params.object_name === 'organizations'"
    />
    <EditCongressList
      v-else-if="this.$route.params.object_name === 'congress'"
    />
    <EditCongressEditionList
      v-else-if="this.$route.params.object_name === 'congressEdition'"
    />
    <EditJournalList
      v-else-if="this.$route.params.object_name === 'journals'"
    />
    <EditEditorialList
      v-else-if="this.$route.params.object_name === 'editorials'"
    />
    <EditResearchAreaList
      v-else-if="this.$route.params.object_name === 'researchAreas'"
    />
    <EditHostList v-else-if="this.$route.params.object_name === 'hosts'" />
    <EditProjectList
      v-else-if="this.$route.params.object_name === 'projects'"
    />
    <EditFunderProgramList
      v-else-if="this.$route.params.object_name === 'funderPrograms'"
    />
    <EditPressNewList
      v-else-if="this.$route.params.object_name === 'pressNews'"
    />
    <EditStayList 
      v-else-if="this.$route.params.object_name === 'stays'" 
    />
    <EditSoftwareList
      v-else-if="this.$route.params.object_name === 'softwares'"
    />
    <EditDatasetList
      v-else-if="this.$route.params.object_name === 'datasets'"
    />
    <EditIndustrialPropertyList
      v-else-if="this.$route.params.object_name === 'industrialProperties'"
    />
  </div>
</template>

<script>
import EditWorkplaceList from "./EditWorkplaceList";
import EditServiceList from "./EditServiceList";
import EditCategoryList from "./EditCategoryList";
import EditOrganizationList from "./EditOrganizationList";
import EditInvestigatorList from "./investigators/EditInvestigatorList";
import EditPublicationList from "./publications/EditPublicationList";
import EditCongressList from "./EditCongressList";
import EditJournalList from "./EditJournalList";
import EditEditorialList from "./EditEditorialList";
import EditCongressEditionList from "./EditCongressEditionList";
import EditResearchAreaList from "./EditResearchAreaList";
import EditHostList from "./EditHostList";
import EditProjectList from "./EditProjectList";
import EditFunderProgramList from "./EditFunderProgramList";
import EditPressNewList from "./EditPressNewList";
import EditStayList from "./EditStayList";
import EditSoftwareList from "./EditSoftwareList";
import EditDatasetList from "./EditDatasetList";
import EditIndustrialPropertyList from "./EditIndustrialPropertyList.vue";
import EditPurchasedLicenseList from "./EditPurchasedLicenseList.vue";

export default {
  name: "EditObject",
  components: {
    EditPurchasedLicenseList,
    EditIndustrialPropertyList,
    EditPressNewList,
    EditFunderProgramList,
    EditResearchAreaList,
    EditEditorialList,
    EditJournalList,
    EditCongressList,
    EditInvestigatorList,
    EditCongressEditionList,
    EditHostList,
    EditProjectList,
    EditOrganizationList,
    EditCategoryList,
    EditServiceList,
    EditWorkplaceList,
    EditPublicationList,
    EditStayList,
    EditSoftwareList,
    EditDatasetList
  },
  created() {
    this.setBreadcrumbAndTitle();
  },

  updated() {
    this.setBreadcrumbAndTitle();
  },

  methods: {
    setBreadcrumbAndTitle() {
      let item = {
        text:
          "section.manage" +
          this.$route.params.object_name.charAt(0).toUpperCase() +
          this.$route.params.object_name.slice(1),
        disabled: true,
        last: true
      };
      if (
        !this.$route.meta.breadCrumb.some(breadcrumb => {
          return breadcrumb.last === true;
        })
      ) {
        this.$route.meta.breadCrumb.push(item);
      } else {
        this.$route.meta.breadCrumb.pop();
        this.$route.meta.breadCrumb.push(item);
      }
      this.$store.state.sectionTitle =
        "section.manage" +
        this.$route.params.object_name.charAt(0).toUpperCase() +
        this.$route.params.object_name.slice(1);
    }
  }
};
</script>

<style scoped></style>
